import clsx from "clsx";
import { FC, useMemo } from "react";
import { useRecoilValue } from "recoil";

import { usePageContext, useRegisterSpecificTableRowId } from "@ryde/redux";
import {
  draggingKanbanRideIdSelector,
  IKanbanItem,
  isHighlightedAfterEditSF,
} from "@ryde/shared";

import {
  KanbanItemPassengers,
  RideKanbanItemCenter,
  RideKanbanItemFooter,
  RideKanbanItemHeader,
} from "./parts";
import {
  KanbanItemStyled,
  LineFooterDivider,
} from "./rides.kanban.item.styled";

export const KanbanItem: FC<IKanbanItem> = ({
  rideDto: dto,
  isDragClone,
}): JSX.Element => {
  const tempRideDragId = useRecoilValue(draggingKanbanRideIdSelector);
  const { entity } = usePageContext();
  useRegisterSpecificTableRowId(dto.id, !isDragClone);

  const isDroppableState = useMemo(() => {
    return tempRideDragId === dto.id && !isDragClone;
  }, [dto, isDragClone, tempRideDragId]);
  const isHighlightedAfterEdit = useRecoilValue(
    isHighlightedAfterEditSF([entity, dto.id]),
  );

  return (
    <KanbanItemStyled
      data-e2e-id={`ride_${dto.id}`}
      className={clsx({
        waiting_drop: isDroppableState,
        kanban_item: true,
        drag_clone: isDragClone,
        after_edit_highlighted: isHighlightedAfterEdit,
      })}
    >
      <RideKanbanItemHeader dto={dto} isDragClone={isDragClone} />
      <RideKanbanItemCenter dto={dto} />

      <KanbanItemPassengers rideDto={dto} />
      <LineFooterDivider />
      <RideKanbanItemFooter dto={dto} />
    </KanbanItemStyled>
  );
};
